export default {"src":"/_next/static/media/Heart_Failure.f1c18771.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};